import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router-dom";
import PageLoadingSpinner from "components/common/PageLoader";
import BreadCrumb from "components/common/BreadCrumb";
import { getDocumentTitle } from "utils/helpers";
import { getEmployeeAdvance } from "features/EmployeeAdvances/services/EmployeeAdvanceService";
import type { EmployeeAdvance } from "features/EmployeeAdvances/types/employee-advance.types";
import EmployeeAdvanceOverviewContext from "./EmployeeAdvanceOverviewContext";
import Section from "./Section";

const EmployeeAdvanceOverview = () => {
  document.title = getDocumentTitle("Employee Advance Details");
  const { id } = useParams();

  const [advance, setAdvance] = useState<EmployeeAdvance | null>(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!id) return;
    const numericId = Number(id);
    try {
      const res = await getEmployeeAdvance(numericId);
      if (res.success) {
        setAdvance(res.data);
      } else {
        setAdvance(null);
      }
    } catch (err) {
      console.warn(err);
      setAdvance(null);
    }
  }, [id]);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (!id) {
        setLoading(false);
        return;
      }
      setLoading(true);
      await refetch();
      if (!cancelled) setLoading(false);
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [id, refetch]);

  if (loading) return <PageLoadingSpinner message="Loading advance…" />;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Employee Advance Details"
          pageTitle="Finance"
          items={[{ label: "Employee Advances", path: "/finance/employee-advances" }]}
        />
        <EmployeeAdvanceOverviewContext.Provider value={{ advance, refetch }}>
          <Section />
        </EmployeeAdvanceOverviewContext.Provider>
      </Container>
    </div>
  );
};

export default EmployeeAdvanceOverview;
